module.exports = __webpack_public_path__ + "static/img/pd_detail_6.cdd574f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footerpic/footerDetailPic/pd_detail_6.jpg
// module id = HIYd
// module chunks = 52